var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infrared-cotainer"},[_c('v-chart',{attrs:{"options":_vm.barOption,"autoresize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }